import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'select2/dist/css/select2.css';
import 'select2';

const inputs = (() => {
  const customPhoneInput = () => {
    const phoneInputElements = document.querySelectorAll(".multiPhoneInput");
    if (phoneInputElements.length > 0) {
      phoneInputElements.forEach((phoneInput, index) => {
        const iti = intlTelInput(phoneInput, {
          initialCountry: "tr",
          preferredCountries: ["tr", "us", "gb"],
          separateDialCode: true,
          autoFormat: true,
          autoHideDialCode: false,
          autoPlaceholder: "polite",
          formatOnDisplay: true,
          // Her input için benzersiz ID
          customContainer: `iti-${index}`,
          // Validation için
          utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
        });
      });
    }
  };

  window.initSelect2 = () => {
    $('.select2-il').select2({
      placeholder: 'İl Seçiniz',
      language: 'tr'
    });
    $('.select2-ilce').select2({
      placeholder: 'İlçe Seçiniz',
      language: 'tr'
    });
  };

  const init = () => {
    customPhoneInput();
    // initSelect2();
    // Bridge Select2 changes to page-level handlers
    $(document).on('change', '.select2-il', function() {
      const il = $('.select2-il').val();
      // Call page-scoped handler if present
      if (typeof window.onBranchSelectChange === 'function') {
        window.onBranchSelectChange(il);
      }
  
    });
    $(document).on('change', '.select2-ilce', function() {
      const ilce = $('.select2-ilce').val();
      // Call page-scoped handler if present
      if (typeof window.onBranchSelectChange === 'function') {
        window.onDistrictSelectChange(ilce);
      }
    });
  };

  return {
    init,
  };
})();

export default inputs;
